import { Chip, Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { teceoOrange } from '../../Theme';
import LangEnum from '../../lang/LangEnum';
import { useTranslation } from '../../modules/translation/TranslationContext';

const useStyles = makeStyles()((theme: Theme) => ({
  chip: {
    backgroundColor: teceoOrange,
    color: 'white',
    marginLeft: theme.spacing(1),
    height: theme.spacing(2),
  },
}));

const NewFeatureChip = () => {
  const { translate } = useTranslation();
  const { classes } = useStyles();

  return (
    <Chip
      component="span"
      label={translate(LangEnum.GLOBAL_NEW)}
      size="small"
      className={classes.chip}
    />
  );
};

export default NewFeatureChip;
